export const CHANGE_LANG = "change-lang";
export const SHOW_LOADING = "show-loading";
export const HIDE_LOADING = "hide-loading";
